"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ccxIngest = require("@ccx-public/ccx-ingest");

var _constants = require("../constants");

var _ingestEvents = _interopRequireDefault(require("../lib/ingestEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var useIngest = function useIngest() {
  var ingest = (0, _ccxIngest.useCCXIngest)(_constants.INGEST_PROJECT_VALUE);
  ingest.events = _ingestEvents.default;
  return ingest;
};

var _default = useIngest;
exports.default = _default;